import { render } from "./CoverageChecker.vue?vue&type=template&id=d2e4c5e2"
import script from "./CoverageChecker.vue?vue&type=script&lang=js"
export * from "./CoverageChecker.vue?vue&type=script&lang=js"

import exportComponent from "/home/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__